(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kn-portada"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('kn-carrusel')) return;

    class KnCarrusel extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.fichas = [...this.querySelectorAll('[data-ficha]')];
        this.minis = [...this.querySelectorAll('[data-miniatura]')];
        this.n = this.slides.length;
        if (this.n < 2) return;
        this.i = 0;
        this.barra = this.querySelector('[data-barra]');
        this.actual = this.querySelector('[data-actual]');
        this.sigNombre = this.querySelector('[data-sig-nombre]');
        this.btnSig = this.querySelector('[data-siguiente]');
        this.btnPausa = this.querySelector('[data-pausa]');
        this.region = this.querySelector('[data-region]');
        this.manual = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hover = false;
        this.foco = false;
        this.fuera = false;

        this.btnSig.addEventListener('click', () => this.ir(this.i + 1));
        this.btnPausa.addEventListener('click', () => {
          this.manual = !this.manual;
          this.estado();
        });
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hover = true;
          this.estado();
        });
        this.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hover = false;
          this.estado();
        });
        this.addEventListener('focusin', () => {
          this.foco = true;
          this.estado();
        });
        this.addEventListener('focusout', (e) => {
          if (this.contains(e.relatedTarget)) return;
          this.foco = false;
          this.estado();
        });
        this.barra.addEventListener('animationend', (e) => {
          if (e.target === this.barra) this.ir(this.i + 1);
        });
        this.io = new IntersectionObserver((entradas) => {
          this.fuera = !entradas[0].isIntersecting;
          this.estado();
        });
        this.io.observe(this);
        this.gestos();
        this.mostrar(0);
        this.estado();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      gestos() {
        const marco = this.querySelector('.kn-portada__marco');
        let x0 = null;
        let arrastro = false;
        marco.addEventListener('pointerdown', (e) => {
          x0 = e.clientX;
          arrastro = false;
        });
        marco.addEventListener('pointerup', (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0;
          x0 = null;
          if (Math.abs(dx) < 40) return;
          arrastro = true;
          this.ir(this.i + (dx < 0 ? 1 : -1));
        });
        marco.addEventListener(
          'click',
          (e) => {
            if (!arrastro) return;
            e.preventDefault();
            arrastro = false;
          },
          true
        );
      }

      ir(k) {
        this.mostrar((k + this.n) % this.n);
      }

      mostrar(k) {
        this.i = k;
        const marcar = (lista) =>
          lista.forEach((el, j) => {
            const activa = j === k;
            el.classList.toggle('is-activa', activa);
            el.toggleAttribute('inert', !activa);
            if (activa) el.removeAttribute('aria-hidden');
            else el.setAttribute('aria-hidden', 'true');
          });
        marcar(this.slides);
        marcar(this.fichas);
        const sig = (k + 1) % this.n;
        this.minis.forEach((m, j) => m.classList.toggle('is-activa', j === sig));
        const nombre = this.slides[sig].dataset.nombre || '';
        if (this.sigNombre) this.sigNombre.textContent = nombre;
        this.btnSig.setAttribute('aria-label', 'Ver siguiente: ' + nombre);
        if (this.actual) this.actual.textContent = String(k + 1).padStart(2, '0');
        this.barra.classList.remove('is-corriendo');
        void this.barra.offsetWidth;
        this.barra.classList.add('is-corriendo');
      }

      estado() {
        const pausado = this.manual || this.hover || this.foco || this.fuera;
        this.toggleAttribute('data-pausado', pausado);
        this.btnPausa.setAttribute('aria-pressed', String(this.manual));
        this.btnPausa.setAttribute('aria-label', this.manual ? 'Reproducir' : 'Pausar');
        this.region.setAttribute('aria-live', pausado ? 'polite' : 'off');
      }
    }

    customElements.define('kn-carrusel', KnCarrusel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
